export default __webpack_public_path__ + "static/media/phases_frame_to_drywall.91e38561.webp";